import { createAction } from '@/utility/actions';

import {
  REPORTS_GET_LIST,
  REPORTS_GET_DETAILS,
  REPORTS_CLEAN_DETAILS,
  REPORTS_GENERATE_REPORT,
  REPORTS_SET_USER_FIELDS,
  REPORTS_GET_DICTIONARY,
  REPORTS_GET_SCHEDULE_SETTINGS,
  REPORTS_SAVE_SCHEDULE_SETTINGS,
  REPORTS_EXTEND_INVITE,
} from './_types.ts';

/**
 * Get Reports list
 * @param {object} params
 */
export const getReports = createAction(REPORTS_GET_LIST);

/**
 * Get Report details
 * @param {number} partner_id
 * @param {object} params
 */
export const getReportDetails = createAction(REPORTS_GET_DETAILS);

export const cleanReportDetails = createAction(REPORTS_CLEAN_DETAILS);

/**
 * Generate report
 * @param {number} partner_id
 * @param {object} params
 */
export const generateReport = createAction(REPORTS_GENERATE_REPORT);

/**
 * Set report user fields
 * @param {object} params
 */
export const setReportUserFields = createAction(REPORTS_SET_USER_FIELDS);

/**
 * Get report dictionary
 * @param {number} partner_id
 * @param {object} params
 */
export const getReportDictionary = createAction(REPORTS_GET_DICTIONARY);

/**
 * Get schedule settings
 * @param {number} report_type
 */
export const getScheduleSettings = createAction(REPORTS_GET_SCHEDULE_SETTINGS);

/**
 * Save schedule settings
 * @param {number} report_type
 * @param {object} data
 * @param {func} onSuccess
 */
export const saveScheduleSettings = createAction(REPORTS_SAVE_SCHEDULE_SETTINGS);

/**
 * Extend an expired streaming reward invite
 * @param {number} invite_id
 * @param {func} onSuccess
 */
export const extendInvite = createAction(REPORTS_EXTEND_INVITE);

export default {
  getReports,
  getReportDetails,
  cleanReportDetails,
  generateReport,
  setReportUserFields,
  getReportDictionary,
  getScheduleSettings,
  saveScheduleSettings,
  extendInvite,
};
